import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getSubAgents,
  getSubAgentVerifyStatus,
  updateSubAgent,
  verifySubAgentStatus,
} from "../actions/subagentActions.js";
import Country from "../components/Country";
import Header from "../components/Header";
import LeftComponent from "../components/LeftComponent";
import {
  SUB_AGENT_GET_RESET,
  SUB_AGENT_UPDATE_RESET,
  SUB_AGENT_VERIFY_ACTION_RESET,
} from "../constants/subagentConstants.js";
import { subagentJson } from "../models/subagentModel";
import User from "../components/Users.js";
import api from "../core/api.js";
import moment from "moment/moment.js";

export default function SubAgentEditScreen2(props) {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [parameters, setParameters] = useState(subagentJson);
  const [executed, setExecuted] = useState(0);
  const [executedtime, setexecutedtime] = useState(0);
  const [verifyFetched, setVerifyFetched] = useState(0);
  const [commissionType, setCommissionType] = useState("");
  const [commissionFile, setCommissionFile] = useState(null);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [uploadMessage, setUploadMessage] = useState("");
  const [agreementDocuments, setAgreementDocuments] = useState([]);

  // NEW: modal state
  // type: 'approve' | 'reject' | 'revoke' | 'reapprove' | null
  const [modal, setModal] = useState({ type: null });
  const [rejectionRemarks, setRejectionRemarks] = useState("");

  const subAgentDetails = useSelector((state) => state.subAgentDetails);
  const {
    loading: loadingDetail,
    error: errorDetail,
    subAgent,
  } = subAgentDetails;
  const subAgentUpdate = useSelector((state) => state.subAgentUpdate);
  const {
    loading: loadingUpdate,
    error: errorUpdate,
    success: successUpdate,
  } = subAgentUpdate;

  const subAgentVerifyStatus =
    useSelector((state) => state.getSubAgentVerifyStatusReducer) || {};
  const {
    loading: loadingVerifyStatus,
    error: errorVerifyStatus,
    verifyStatus,
  } = subAgentVerifyStatus;

  const subAgentVerifyAction =
    useSelector((state) => state.verifySubAgentStatusReducer) || {};
  const {
    loading: loadingVerifyAction,
    error: errorVerifyAction,
    success: successVerifyAction,
  } = subAgentVerifyAction;

  const handleSubAgentValue = (e) => {
    setParameters({ ...parameters, [e.target.name]: e.target.value });
  };
  const UpdateSubAgent = (e) => {
    dispatch(updateSubAgent(id, parameters));
    setexecutedtime(1);
    setExecuted(0);
  };

  // Modal openers
  const openApprove = () => setModal({ type: "approve" });
  const openReject = () => {
    setRejectionRemarks("");
    setModal({ type: "reject" });
  };
  const openRevoke = () => setModal({ type: "revoke" });
  const openReApprove = () => setModal({ type: "reapprove" });
  const closeModal = () => {
    setModal({ type: null });
    setRejectionRemarks("");
  };

  // Modal confirmers — call APIs (unchanged)
  const confirmApprove = () => {
    dispatch(verifySubAgentStatus({ Company_Id: id, Status: 1 }));
    closeModal();
  };
  const confirmReject = () => {
    dispatch(
      verifySubAgentStatus({
        Company_Id: id,
        Status: 2,
        Blocked_Reason: rejectionRemarks,
      }),
    );
    closeModal();
  };
  const confirmRevoke = () => {
    dispatch(
      verifySubAgentStatus({ Company_Id: id, Status: 2, action: "revoke" }),
    );
    closeModal();
  };
  const confirmReApprove = () => {
    dispatch(
      verifySubAgentStatus({ Company_Id: id, Status: 1, action: "reapprove" }),
    );
    closeModal();
  };

  const getAgreementDocuments = async () => {
    const { data } = await api.get(`/api/subagent/agreement/${id}`);

    setAgreementDocuments(data);
  };

  useEffect(() => {
    getAgreementDocuments();
  }, [id]);

  const fmtDate = (d) => {
    if (!d) return "";
    try {
      const dt = new Date(d);
      if (isNaN(dt.getTime())) return d;
      return dt.toLocaleDateString(undefined, {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    } catch (err) {
      return d;
    }
  };

  const uploadCommission = async () => {
    try {
      if (!commissionFile) {
        alert("Please select Agreement PDF");
        return;
      }

      setUploadLoading(true);

      const formData = new FormData();

      formData.append("Company_Id", id);
      formData.append("Comission_Type", "Partner_Agreement");
      formData.append("file", commissionFile);
      const authToken = JSON.parse(localStorage.getItem("accinf"));
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/accounts/subagentcommission`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
          body: formData,
        },
      );

      const data = await response.json();

      if (response.ok) {
        setUploadMessage("Agreement uploaded successfully");
        setCommissionType("");
        setCommissionFile(null);

        document.getElementById("commissionPdf").value = "";
      } else {
        setUploadMessage(data.Result || "Upload failed");
      }
    } catch (err) {
      console.log(err);
      setUploadMessage("Upload failed");
    } finally {
      setUploadLoading(false);
    }
  };

  useEffect(() => {
    if (successUpdate) {
      setTimeout(() => {
        dispatch({ type: SUB_AGENT_UPDATE_RESET });
      }, 10000);
    }
    if (executed == 0) {
      dispatch({ type: SUB_AGENT_GET_RESET });
      setExecuted(1);
    }
    if (subAgent == undefined || subAgent.length == 0) {
      setexecutedtime(executedtime + 1);
      if (executedtime < 5 && executedtime > 0) {
        dispatch(getSubAgents(id));
      } else if (executedtime < 8) {
        //console.log(subAgent)
      }
    } else {
      setParameters(subAgent[0]);
    }
  }, [dispatch, id, subAgent, successUpdate]);

  useEffect(() => {
    if (id && verifyFetched === 0) {
      dispatch(getSubAgentVerifyStatus(id));
      setVerifyFetched(1);
    }
    if (successVerifyAction) {
      dispatch(getSubAgentVerifyStatus(id));
      setTimeout(() => {
        dispatch({ type: SUB_AGENT_VERIFY_ACTION_RESET });
      }, 8000);
    }
  }, [dispatch, id, successVerifyAction]);

  // Lock body scroll while modal is open
  useEffect(() => {
    if (modal.type) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [modal.type]);

  const vs = { ...verifyStatus } || {};
  const isVerified = Number(vs.Is_Verified) == 1;
  const isRejected = Number(vs.Is_Verified) == 2;
  const isPending = !isVerified && !isRejected;

  return (
    <>
      <Header pageName="Sub Agent" />
      <LeftComponent />
      <div className="content-body">
        <div className="container-fluid">
          <div className="heading-title">
            <div className="row">
              <div className="col-md-12">
                <div className="home-title float-left"></div>
              </div>
            </div>
          </div>
          <div className="inner-body">
            <div className="invoice-details">
              <div className="" style={{ padding: "20px" }}>
                <div className="row">
                  <div className="col-lg-9 col-md-8">
                    <div id="InvoiceAccordion" className="accordion-invoice">
                      <div className="card mb-0">
                        <div
                          className="card-header collapsed"
                          data-toggle="collapse"
                          href="#collapseOne"
                        >
                          <a className="card-title">Sub Agent Details</a>
                        </div>
                        {/* <div className="card-body collapse show">
                          <div className="row">
                            <div className="col-md-6">
                              <div className="row mt-3">
                                <div className="col-sm-4">
                                  <label className="pt-1 mb-0">
                                    Sub Agent Name* &nbsp; &nbsp;
                                  </label>
                                </div>
                                <div className="col-sm-8 input-group input-group-sm">
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    placeholder="sub agent name"
                                    name="SubAgent_Name"
                                    value={parameters.SubAgent_Name}
                                    onChange={(e) => handleSubAgentValue(e)}
                                  />
                                </div>
                              </div>
                              <div className="row mt-3">
                                <div className="col-sm-4">
                                  <label className="pt-1 mb-0">
                                    Sub Agent Address* &nbsp; &nbsp;
                                  </label>
                                </div>
                                <div className="col-sm-8 input-group input-group-sm">
                                  <textarea
                                    className="form-control form-control-sm"
                                    placeholder="address..."
                                    name="SubAgent_Address"
                                    value={parameters.SubAgent_Address}
                                    onChange={(e) => handleSubAgentValue(e)}
                                  ></textarea>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="row mt-3">
                                <div className="col-sm-4">
                                  <label className="pt-1 mb-0">
                                    Country* &nbsp; &nbsp;
                                  </label>
                                </div>
                                <div className="col-sm-8 input-group input-group-sm">
                                  <select
                                    className="form-control form-control-sm"
                                    name="Country_Id"
                                    value={parameters.Country_Id}
                                    onChange={(e) => handleSubAgentValue(e)}
                                  >
                                    <option value="">--Select--</option>
                                    <Country />
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div> */}
                        <div className="card-body collapse show">
                          <div className="row">
                            {/* LEFT COLUMN */}
                            <div className="col-md-6">
                              <div className="row mt-3">
                                <div className="col-sm-4">
                                  <label className="pt-1 mb-0">
                                    Sub Agent Name*
                                  </label>
                                </div>
                                <div className="col-sm-8 input-group input-group-sm">
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    name="SubAgent_Name"
                                    value={parameters.SubAgent_Name || ""}
                                    onChange={handleSubAgentValue}
                                    placeholder="Sub Agent Name"
                                  />
                                </div>
                              </div>

                              <div className="row mt-3">
                                <div className="col-sm-4">
                                  <label className="pt-1 mb-0">
                                    Company Type
                                  </label>
                                </div>
                                <div className="col-sm-8 input-group input-group-sm">
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    name="Company_Type"
                                    value={parameters.Company_Type || ""}
                                    onChange={handleSubAgentValue}
                                    placeholder="Company Type"
                                  />
                                </div>
                              </div>

                              <div className="row mt-3">
                                <div className="col-sm-4">
                                  <label className="pt-1 mb-0">
                                    Company Website
                                  </label>
                                </div>
                                <div className="col-sm-8 input-group input-group-sm">
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    name="Company_Website"
                                    value={parameters.Company_Website || ""}
                                    onChange={handleSubAgentValue}
                                    placeholder="https://example.com"
                                  />
                                </div>
                              </div>

                              <div className="row mt-3">
                                <div className="col-sm-4">
                                  <label className="pt-1 mb-0">
                                    GST Number
                                  </label>
                                </div>
                                <div className="col-sm-8 input-group input-group-sm">
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    name="GST_Number"
                                    value={parameters.GST_Number || ""}
                                    onChange={handleSubAgentValue}
                                    placeholder="GST Number"
                                  />
                                </div>
                              </div>

                              <div className="row mt-3">
                                <div className="col-sm-4">
                                  <label className="pt-1 mb-0">
                                    PAN Number
                                  </label>
                                </div>
                                <div className="col-sm-8 input-group input-group-sm">
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    name="PAN_Number"
                                    value={parameters.PAN_Number || ""}
                                    onChange={handleSubAgentValue}
                                    placeholder="PAN Number"
                                  />
                                </div>
                              </div>

                              <div className="row mt-3">
                                <div className="col-sm-4">
                                  <label className="pt-1 mb-0">
                                    Registration No.
                                  </label>
                                </div>
                                <div className="col-sm-8 input-group input-group-sm">
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    name="Registration_Number"
                                    value={parameters.Registration_Number || ""}
                                    onChange={handleSubAgentValue}
                                    placeholder="Registration Number"
                                  />
                                </div>
                              </div>
                            </div>

                            {/* RIGHT COLUMN */}
                            <div className="col-md-6">
                              <div className="row mt-3">
                                <div className="col-sm-4">
                                  <label className="pt-1 mb-0">Address</label>
                                </div>
                                <div className="col-sm-8 input-group input-group-sm">
                                  <textarea
                                    className="form-control form-control-sm"
                                    rows="4"
                                    name="SubAgent_Address"
                                    value={parameters.SubAgent_Address ?? ""}
                                    onChange={handleSubAgentValue}
                                    placeholder="Company Address"
                                  />
                                </div>
                              </div>

                              <div className="row mt-3">
                                <div className="col-sm-4">
                                  <label className="pt-1 mb-0">Country</label>
                                </div>
                                <div className="col-sm-8 input-group input-group-sm">
                                  <select
                                    className="form-control form-control-sm"
                                    name="Country_Id"
                                    value={parameters.Country_Id ?? ""}
                                    onChange={handleSubAgentValue}
                                  >
                                    <option value="">
                                      -- Select Country --
                                    </option>
                                    <Country />
                                  </select>
                                </div>
                              </div>

                              <div className="row mt-3">
                                <div className="col-sm-4">
                                  <label className="pt-1 mb-0">
                                    Partner Head
                                  </label>
                                </div>
                                <div className="col-sm-8 input-group input-group-sm">
                                  <select
                                    className="form-control form-control-sm"
                                    name="Partner_Head"
                                    value={parameters.Partner_Head || ""}
                                    onChange={handleSubAgentValue}
                                  >
                                    <option value="">
                                      Select Partner Head
                                    </option>
                                    <User getAll={true} />
                                  </select>
                                </div>
                              </div>

                              <div className="row mt-3">
                                <div className="col-sm-4">
                                  <label className="pt-1 mb-0">Notes</label>
                                </div>
                                <div className="col-sm-8 input-group input-group-sm">
                                  <textarea
                                    className="form-control form-control-sm"
                                    rows="5"
                                    disabled={true}
                                    name="Notes"
                                    value={parameters.Notes?.trim() || ""}
                                    onChange={handleSubAgentValue}
                                    placeholder="Notes / Details Shared"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="card-header collapsed">
                          <a className="card-title">Other Details</a>
                        </div>
                        <div className="card-body collapse show">
                          <div className="row">
                            <div className="col-md-6">
                              <div className="row mt-3">
                                <div className="col-sm-4">
                                  <label className="pt-1 mb-0">
                                    Contact Person*
                                  </label>
                                </div>
                                <div className="col-sm-8 input-group input-group-sm">
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    name="Contact_Person"
                                    value={parameters.Contact_Person}
                                    onChange={(e) => handleSubAgentValue(e)}
                                    placeholder="contact person"
                                  />
                                </div>
                              </div>
                              <div className="row mt-3">
                                <div className="col-sm-4">
                                  <label className="pt-1 mb-0">
                                    Contact Person Email*
                                  </label>
                                </div>
                                <div className="col-sm-8 input-group input-group-sm">
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    name="Contact_Email"
                                    value={parameters.Contact_Email}
                                    onChange={(e) => handleSubAgentValue(e)}
                                    placeholder="contact person email"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="row mt-3">
                                <div className="col-sm-4">
                                  <label className="pt-1 mb-0">
                                    Contact Person Number*
                                  </label>
                                </div>
                                <div className="col-sm-8 input-group input-group-sm">
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    name="Contact_Number"
                                    value={parameters.Contact_Number}
                                    onChange={(e) => handleSubAgentValue(e)}
                                    placeholder="contact person number"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="card-header collapsed">
                          <a className="card-title">Commission Details</a>
                        </div>
                        <div
                          id="collapseThree"
                          className="card-body collapse  show"
                        >
                          <div className="row">
                            <div className="col-md-6">
                              <div className="row mt-3">
                                <div className="col-sm-4">
                                  <label className="pt-1 mb-0">
                                    Split Percentage*
                                  </label>
                                </div>
                                <div className="col-sm-8 input-group input-group-sm">
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    placeholder="split percentage"
                                    name="Split_Percentage"
                                    value={parameters.Split_Percentage}
                                    onChange={(e) => handleSubAgentValue(e)}
                                  />
                                  <div className="input-group-prepend">
                                    <span className="input-group-text">%</span>
                                  </div>
                                </div>
                              </div>
                              <div className="row mt-3">
                                <div className="col-sm-4">
                                  <label className="pt-1 mb-0">
                                    Commission Percentage UG*
                                  </label>
                                </div>
                                <div className="col-sm-8 input-group input-group-sm">
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    placeholder="commission percentage"
                                    name="Commision_Percentage_UG"
                                    value={parameters.Commision_Percentage_UG}
                                    onChange={(e) => handleSubAgentValue(e)}
                                  />
                                  <div className="input-group-prepend">
                                    <span className="input-group-text">%</span>
                                  </div>
                                </div>
                              </div>
                              <div className="row mt-3">
                                <div className="col-sm-4">
                                  <label className="pt-1 mb-0">
                                    Commision Percentage_PG*
                                  </label>
                                </div>
                                <div className="col-sm-8 input-group input-group-sm">
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    placeholder="commission percentage pg"
                                    name="Commision_Percentage_PG"
                                    value={parameters.Commision_Percentage_PG}
                                    onChange={(e) => handleSubAgentValue(e)}
                                  />
                                  <div className="input-group-prepend">
                                    <span className="input-group-text">%</span>
                                  </div>
                                </div>
                              </div>
                              <div className="row mt-3">
                                <div className="col-sm-4">
                                  <label className="pt-1 mb-0">
                                    Commision Percentage_Other*
                                  </label>
                                </div>
                                <div className="col-sm-8 input-group input-group-sm">
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    placeholder="commission percentage other"
                                    name="Commision_Percentage_Other"
                                    value={
                                      parameters.Commision_Percentage_Other
                                    }
                                    onChange={(e) => handleSubAgentValue(e)}
                                  />
                                  <div className="input-group-prepend">
                                    <span className="input-group-text">%</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="row mt-3">
                                <div className="col-sm-4">
                                  <label className="pt-1 mb-0">
                                    Lumpsum_Commision
                                  </label>
                                </div>
                                <div className="col-sm-8 input-group input-group-sm">
                                  <div className="input-group-prepend">
                                    <span className="input-group-text">$</span>
                                  </div>
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    placeholder="Lumpson Commission"
                                    name="Lumpsum_Commision"
                                    value={parameters.Lumpsum_Commision}
                                    onChange={(e) => handleSubAgentValue(e)}
                                  />
                                </div>
                              </div>
                              <div className="row mt-3">
                                <div className="col-sm-4">
                                  <label className="pt-1 mb-0">
                                    Commision Including GST
                                  </label>
                                </div>
                                <div className="col-sm-8 input-group input-group-sm">
                                  <select
                                    type="text"
                                    className="form-control form-control-sm"
                                    name="Commision_Including_GST"
                                    value={parameters.Commision_Including_GST}
                                    onChange={(e) => handleSubAgentValue(e)}
                                  >
                                    <option value="">--Select--</option>
                                    <option value="1">Yes</option>
                                    <option value="0">No</option>
                                  </select>
                                </div>
                              </div>
                              <div className="row mt-3">
                                <div className="col-sm-4">
                                  <label className="pt-1 mb-0">
                                    Commission Duration
                                  </label>
                                </div>
                                <div className="col-sm-8 input-group input-group-sm">
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    name="Commission_Duration"
                                    value={parameters.Commission_Duration}
                                    onChange={(e) => handleSubAgentValue(e)}
                                    placeholder="commission duration"
                                  />
                                </div>
                              </div>
                            </div>
                            {/* upload commissio  */}

                            <div className="col-md-12 text-center">
                              <hr />
                              <>
                                {loadingUpdate ? (
                                  <div className="Create-btn">Loading...</div>
                                ) : (
                                  <div className="Create-btn">
                                    <a
                                      className="btn create-contact"
                                      onClick={(e) => UpdateSubAgent(e)}
                                    >
                                      Update
                                    </a>
                                  </div>
                                )}
                              </>
                              <span className="text-success">
                                {successUpdate}
                              </span>
                              <span className="text-danger">{errorUpdate}</span>
                            </div>

                            <div className="col-md-12 mt-5">
                              <hr />

                              <h5 className="mb-4">
                                Upload Agreement Document
                              </h5>

                              <div className="row">
                                {/* <div className="col-md-5">
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    placeholder="Commission Type"
                                    value={commissionType}
                                    onChange={(e) =>
                                      setCommissionType(e.target.value)
                                    }
                                  />
                                </div> */}

                                <div className="col-md-5">
                                  <input
                                    id="commissionPdf"
                                    type="file"
                                    className="form-control form-control-sm"
                                    accept="application/pdf"
                                    onChange={(e) =>
                                      setCommissionFile(e.target.files[0])
                                    }
                                  />
                                </div>

                                <div className="col-md-2">
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm w-100"
                                    onClick={uploadCommission}
                                    disabled={uploadLoading}
                                  >
                                    {uploadLoading ? "Uploading..." : "Upload"}
                                  </button>
                                </div>
                              </div>

                              {uploadMessage && (
                                <div className="mt-2">
                                  <small className="text-success">
                                    {uploadMessage}
                                  </small>
                                </div>
                              )}
                            </div>

                            <div className="col-md-12 mt-4">
                              <h5 className="mb-3">Uploaded Documents</h5>

                              <div className="table-responsive">
                                <table className="table table-bordered table-sm">
                                  <thead>
                                    <tr>
                                      <th width="60">#</th>
                                      <th>Document Name</th>
                                      <th>Uploaded On</th>
                                      <th width="180">Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {agreementDocuments?.length > 0 ? (
                                      agreementDocuments.map((doc, index) => (
                                        <tr key={doc.Id}>
                                          <td>{index + 1}</td>
                                          <td>{doc.File_Name}</td>
                                          <td>
                                            {moment(doc.Created_On).format(
                                              "DD MMM YYYY",
                                            )}
                                          </td>
                                          <td>
                                            <a
                                              href={doc.File_Path}
                                              target="_blank"
                                              rel="noreferrer"
                                              className="btn btn-info btn-sm me-2"
                                            >
                                              View
                                            </a>

                                            <a
                                              href={doc.File_Path}
                                              download
                                              className="btn btn-success btn-sm me-2"
                                            >
                                              Download
                                            </a>
                                          </td>
                                        </tr>
                                      ))
                                    ) : (
                                      <tr>
                                        <td colSpan="4" className="text-center">
                                          No documents uploaded.
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* ============================================= */}
                  {/* Right side Partner Verification panel          */}
                  {/* ============================================= */}
                  <div className="col-lg-3 col-md-4">
                    <div className="sav-panel">
                      <div className="sav-panel-header">
                        <span className="sav-panel-title">
                          Subagent Verification
                        </span>
                      </div>
                      {/* details */}

                      {/* details */}
                      <div className="sav-panel-body">
                        {loadingVerifyStatus ? (
                          <div className="sav-loading">
                            <span className="sav-spinner"></span>
                            <small>Loading verification status...</small>
                          </div>
                        ) : errorVerifyStatus ? (
                          <div className="sav-alert sav-alert-danger">
                            <small>{errorVerifyStatus}</small>
                          </div>
                        ) : (
                          <>
                            {/* VERIFIED STATE */}
                            {isVerified && (
                              <div className="sav-state">
                                <div className="sav-badge sav-badge-success">
                                  <i className="fa fa-check-circle"></i>{" "}
                                  Verified Partner
                                </div>
                                <div className="sav-meta">
                                  <div className="sav-meta-label">
                                    Approved on
                                  </div>
                                  <div className="sav-meta-value">
                                    {fmtDate(vs.Verified_At)}
                                  </div>
                                </div>
                                {vs.Verified_By && (
                                  <div className="sav-meta">
                                    <div className="sav-meta-label">
                                      Approved by
                                    </div>
                                    <div className="sav-meta-value">
                                      {vs.Verified_By_Name}
                                    </div>
                                  </div>
                                )}
                                <div className="sav-divider"></div>
                                {loadingVerifyAction ? (
                                  <button
                                    className="sav-btn sav-btn-secondary"
                                    disabled
                                  >
                                    Processing...
                                  </button>
                                ) : (
                                  <button
                                    className="sav-btn sav-btn-outline-danger"
                                    onClick={openRevoke}
                                  >
                                    Revoke Verification
                                  </button>
                                )}
                                <p className="sav-helper">
                                  Revoking will remove this partner from the
                                  verified directory.
                                </p>
                              </div>
                            )}

                            {/* REJECTED STATE */}
                            {isRejected && (
                              <div className="sav-state">
                                <div className="sav-badge sav-badge-danger">
                                  <i className="fa fa-times-circle"></i>{" "}
                                  Rejected
                                </div>
                                <div className="sav-meta">
                                  <div className="sav-meta-label">
                                    Rejected on
                                  </div>
                                  <div className="sav-meta-value">
                                    {fmtDate(
                                      vs.rejected_date || vs.Verified_At,
                                    )}
                                  </div>
                                </div>
                                {vs.Blocked_Reason && (
                                  <div className="sav-reason">
                                    <strong>Reason:</strong> {vs.Blocked_Reason}
                                  </div>
                                )}
                                {vs.Verified_By && (
                                  <div className="sav-meta">
                                    <div className="sav-meta-label">
                                      Rejected by
                                    </div>
                                    <div className="sav-meta-value">
                                      {vs.Verified_By_Name}
                                    </div>
                                  </div>
                                )}
                                <div className="sav-divider"></div>
                                {loadingVerifyAction ? (
                                  <button
                                    className="sav-btn sav-btn-secondary"
                                    disabled
                                  >
                                    Processing...
                                  </button>
                                ) : (
                                  <button
                                    className="sav-btn sav-btn-success"
                                    onClick={openReApprove}
                                  >
                                    Approve as Partner
                                  </button>
                                )}
                                <p className="sav-helper">
                                  Reversing rejection will onboard this sub
                                  agent as a verified partner.
                                </p>
                              </div>
                            )}

                            {/* PENDING STATE */}
                            {isPending && (
                              <div className="sav-state">
                                <div className="sav-badge sav-badge-warning">
                                  <i className="fa fa-clock-o"></i> Pending
                                  Verification
                                </div>
                                <p className="sav-helper sav-helper-top">
                                  Review the sub agent's details and either
                                  approve them as a verified business partner or
                                  reject the onboarding.
                                </p>
                                <div className="sav-divider"></div>
                                {loadingVerifyAction ? (
                                  <button
                                    className="sav-btn sav-btn-secondary"
                                    disabled
                                  >
                                    Processing...
                                  </button>
                                ) : (
                                  <>
                                    <button
                                      className="sav-btn sav-btn-success sav-mb-8"
                                      onClick={openApprove}
                                    >
                                      <i className="fa fa-check"></i> Approve
                                      &amp; Verify
                                    </button>
                                    <button
                                      className="sav-btn sav-btn-outline-danger"
                                      onClick={openReject}
                                    >
                                      <i className="fa fa-times"></i> Reject
                                      Onboarding
                                    </button>
                                  </>
                                )}
                              </div>
                            )}

                            {successVerifyAction && (
                              <div className="sav-alert sav-alert-success">
                                {typeof successVerifyAction === "string"
                                  ? successVerifyAction
                                  : "Status updated successfully."}
                              </div>
                            )}
                            {errorVerifyAction && (
                              <div className="sav-alert sav-alert-danger">
                                {errorVerifyAction}
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ===================== MODALS ===================== */}
      {modal.type && (
        <div
          className="sav-modal-overlay"
          onClick={(e) => {
            if (e.target.classList.contains("sav-modal-overlay")) closeModal();
          }}
        >
          <div className="sav-modal" role="dialog" aria-modal="true">
            {/* Approve modal */}
            {modal.type === "approve" && (
              <>
                <div className="sav-modal-header sav-modal-header-success">
                  <span className="sav-modal-icon">
                    <i className="fa fa-check-circle"></i>
                  </span>
                  <h5 className="sav-modal-title">Approve &amp; Verify</h5>
                  <button
                    className="sav-modal-close"
                    onClick={closeModal}
                    aria-label="Close"
                  >
                    &times;
                  </button>
                </div>
                <div className="sav-modal-body">
                  <p>
                    Are you sure you want to approve this Sub Agent as a{" "}
                    <strong>verified business partner</strong>?
                  </p>
                  <p className="sav-modal-note">
                    Once approved, they will be listed in the verified partner
                    directory and gain access to partner-only features.
                  </p>
                </div>
                <div className="sav-modal-footer">
                  <button
                    className="sav-btn sav-btn-light"
                    onClick={closeModal}
                  >
                    Cancel
                  </button>
                  <button
                    className="sav-btn sav-btn-success"
                    onClick={confirmApprove}
                  >
                    Yes, Approve
                  </button>
                </div>
              </>
            )}

            {/* Reject modal */}
            {modal.type === "reject" && (
              <>
                <div className="sav-modal-header sav-modal-header-danger">
                  <span className="sav-modal-icon">
                    <i className="fa fa-times-circle"></i>
                  </span>
                  <h5 className="sav-modal-title">Reject Onboarding</h5>
                  <button
                    className="sav-modal-close"
                    onClick={closeModal}
                    aria-label="Close"
                  >
                    &times;
                  </button>
                </div>
                <div className="sav-modal-body">
                  <p>
                    You are about to reject this Sub Agent's onboarding. Please
                    provide a reason for the rejection (optional but
                    recommended).
                  </p>
                  <label className="sav-modal-label">Rejection reason</label>
                  <textarea
                    className="sav-modal-textarea"
                    rows="4"
                    placeholder="e.g. Incomplete documentation, commission terms not agreed, etc."
                    value={rejectionRemarks}
                    onChange={(e) => setRejectionRemarks(e.target.value)}
                  ></textarea>
                </div>
                <div className="sav-modal-footer">
                  <button
                    className="sav-btn sav-btn-light"
                    onClick={closeModal}
                  >
                    Cancel
                  </button>
                  <button
                    className="sav-btn sav-btn-danger"
                    onClick={confirmReject}
                  >
                    Confirm Reject
                  </button>
                </div>
              </>
            )}

            {/* Revoke modal */}
            {modal.type === "revoke" && (
              <>
                <div className="sav-modal-header sav-modal-header-danger">
                  <span className="sav-modal-icon">
                    <i className="fa fa-exclamation-triangle"></i>
                  </span>
                  <h5 className="sav-modal-title">Revoke Verification</h5>
                  <button
                    className="sav-modal-close"
                    onClick={closeModal}
                    aria-label="Close"
                  >
                    &times;
                  </button>
                </div>
                <div className="sav-modal-body">
                  <p>
                    Revoke verification for this Sub Agent? They will no longer
                    appear as an approved partner.
                  </p>
                  <p className="sav-modal-note">
                    This action can be reversed later by approving the Sub Agent
                    again.
                  </p>
                </div>
                <div className="sav-modal-footer">
                  <button
                    className="sav-btn sav-btn-light"
                    onClick={closeModal}
                  >
                    Cancel
                  </button>
                  <button
                    className="sav-btn sav-btn-danger"
                    onClick={confirmRevoke}
                  >
                    Yes, Revoke
                  </button>
                </div>
              </>
            )}

            {/* Re-approve modal */}
            {modal.type === "reapprove" && (
              <>
                <div className="sav-modal-header sav-modal-header-success">
                  <span className="sav-modal-icon">
                    <i className="fa fa-undo"></i>
                  </span>
                  <h5 className="sav-modal-title">Approve as Partner</h5>
                  <button
                    className="sav-modal-close"
                    onClick={closeModal}
                    aria-label="Close"
                  >
                    &times;
                  </button>
                </div>
                <div className="sav-modal-body">
                  <p>
                    Reverse the rejection and approve this Sub Agent as a{" "}
                    <strong>verified business partner</strong>?
                  </p>
                  <p className="sav-modal-note">
                    The previous rejection record will be cleared and they will
                    move to verified status.
                  </p>
                </div>
                <div className="sav-modal-footer">
                  <button
                    className="sav-btn sav-btn-light"
                    onClick={closeModal}
                  >
                    Cancel
                  </button>
                  <button
                    className="sav-btn sav-btn-success"
                    onClick={confirmReApprove}
                  >
                    Yes, Approve
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {/* ===================== PAGE-SCOPED CSS ===================== */}
      <style>{`
        /* Verification side panel */
        .sav-panel {
          position: sticky;
          top: 90px;
          background: #fff;
          border: 1px solid #e6e9ef;
          border-radius: 10px;
          box-shadow: 0 2px 8px rgba(16, 24, 40, 0.04);
          overflow: hidden;
        }
        .sav-panel-header {
          padding: 14px 18px;
          background: linear-gradient(135deg, #f8fafc 0%, #eef2f7 100%);
          border-bottom: 1px solid #e6e9ef;
        }
        .sav-panel-title {
          font-size: 0.95rem;
          font-weight: 600;
          color: #1f2d3d;
          letter-spacing: 0.2px;
        }
        .sav-panel-body {
          padding: 18px;
        }
        .sav-state {
          text-align: center;
        }

        /* Status badges */
        .sav-badge {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding: 6px 12px;
          border-radius: 999px;
          font-size: 0.82rem;
          font-weight: 600;
          margin-bottom: 14px;
        }
        .sav-badge i { font-size: 0.9rem; }
        .sav-badge-success {
          background: #e6f7ec;
          color: #1b7a3e;
          border: 1px solid #b8e6c8;
        }
        .sav-badge-danger {
          background: #fdecec;
          color: #b42318;
          border: 1px solid #f5c6c6;
        }
        .sav-badge-warning {
          background: #fff7e6;
          color: #b54708;
          border: 1px solid #fde2b0;
        }

        /* Meta blocks */
        .sav-meta {
          margin: 8px 0;
        }
        .sav-meta-label {
          font-size: 0.72rem;
          color: #667085;
          text-transform: uppercase;
          letter-spacing: 0.4px;
        }
        .sav-meta-value {
          font-size: 0.92rem;
          color: #1f2d3d;
          font-weight: 600;
        }
        .sav-reason {
          background: #f9fafb;
          border: 1px solid #eef0f3;
          border-radius: 6px;
          padding: 8px 10px;
          font-size: 0.82rem;
          color: #344054;
          text-align: left;
          margin: 10px 0;
        }
        .sav-divider {
          height: 1px;
          background: #eef0f3;
          margin: 14px 0;
        }
        .sav-helper {
          font-size: 0.75rem;
          color: #667085;
          margin: 10px 0 0;
          line-height: 1.4;
        }
        .sav-helper-top { margin: 0 0 4px; }

        /* Buttons */
        .sav-btn {
          width: 100%;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          padding: 8px 14px;
          font-size: 0.86rem;
          font-weight: 600;
          border-radius: 6px;
          border: 1px solid transparent;
          cursor: pointer;
          transition: all 0.15s ease;
          line-height: 1.2;
        }
        .sav-btn:disabled { opacity: 0.6; cursor: not-allowed; }
        .sav-btn-success { background: #16a34a; color: #fff; border-color: #16a34a; }
        .sav-btn-success:hover:not(:disabled) { background: #15803d; border-color: #15803d; }
        .sav-btn-danger { background: #dc2626; color: #fff; border-color: #dc2626; }
        .sav-btn-danger:hover:not(:disabled) { background: #b91c1c; border-color: #b91c1c; }
        .sav-btn-outline-danger { background: #fff; color: #dc2626; border-color: #fca5a5; }
        .sav-btn-outline-danger:hover:not(:disabled) { background: #fef2f2; border-color: #dc2626; }
        .sav-btn-light { background: #f3f4f6; color: #344054; border-color: #e5e7eb; }
        .sav-btn-light:hover:not(:disabled) { background: #e5e7eb; }
        .sav-btn-secondary { background: #f3f4f6; color: #667085; border-color: #e5e7eb; }
        .sav-mb-8 { margin-bottom: 8px; }

        /* Loading + alerts */
        .sav-loading {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          color: #667085;
          padding: 16px 0;
        }
        .sav-spinner {
          width: 14px;
          height: 14px;
          border: 2px solid #e6e9ef;
          border-top-color: #2563eb;
          border-radius: 50%;
          animation: sav-spin 0.8s linear infinite;
          display: inline-block;
        }
        @keyframes sav-spin { to { transform: rotate(360deg); } }
        .sav-alert {
          font-size: 0.82rem;
          border-radius: 6px;
          padding: 8px 12px;
          margin-top: 14px;
          text-align: center;
        }
        .sav-alert-success {
          background: #e6f7ec;
          color: #1b7a3e;
          border: 1px solid #b8e6c8;
        }
        .sav-alert-danger {
          background: #fdecec;
          color: #b42318;
          border: 1px solid #f5c6c6;
        }

        /* Modal */
        .sav-modal-overlay {
          position: fixed;
          inset: 0;
          background: rgba(15, 23, 42, 0.55);
          z-index: 1050;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 16px;
          animation: sav-fade 0.15s ease-out;
        }
        @keyframes sav-fade {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        .sav-modal {
          background: #fff;
          width: 100%;
          max-width: 460px;
          border-radius: 12px;
          box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);
          overflow: hidden;
          animation: sav-pop 0.18s ease-out;
        }
        @keyframes sav-pop {
          from { transform: translateY(8px) scale(0.98); opacity: 0; }
          to { transform: translateY(0) scale(1); opacity: 1; }
        }
        .sav-modal-header {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 14px 18px;
          border-bottom: 1px solid #eef0f3;
          background: #fff;
        }
        .sav-modal-header-success { background: #f0fdf4; }
        .sav-modal-header-danger { background: #fef2f2; }
        .sav-modal-icon {
          font-size: 1.25rem;
          line-height: 1;
        }
        .sav-modal-header-success .sav-modal-icon { color: #16a34a; }
        .sav-modal-header-danger .sav-modal-icon { color: #dc2626; }
        .sav-modal-title {
          flex: 1;
          margin: 0;
          font-size: 1rem;
          font-weight: 600;
          color: #1f2d3d;
        }
        .sav-modal-close {
          background: transparent;
          border: 0;
          font-size: 1.5rem;
          line-height: 1;
          color: #667085;
          cursor: pointer;
          padding: 0 4px;
        }
        .sav-modal-close:hover { color: #1f2d3d; }
        .sav-modal-body {
          padding: 18px;
          font-size: 0.9rem;
          color: #344054;
          line-height: 1.5;
        }
        .sav-modal-body p { margin: 0 0 10px; }
        .sav-modal-note {
          font-size: 0.82rem;
          color: #667085;
        }
        .sav-modal-label {
          display: block;
          font-size: 0.78rem;
          font-weight: 600;
          color: #344054;
          margin: 8px 0 4px;
        }
        .sav-modal-textarea {
          width: 100%;
          border: 1px solid #d0d5dd;
          border-radius: 6px;
          padding: 8px 10px;
          font-size: 0.88rem;
          color: #1f2d3d;
          resize: vertical;
          font-family: inherit;
        }
        .sav-modal-textarea:focus {
          outline: none;
          border-color: #2563eb;
          box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
        }
        .sav-modal-footer {
          display: flex;
          justify-content: flex-end;
          gap: 8px;
          padding: 14px 18px;
          border-top: 1px solid #eef0f3;
          background: #fafbfc;
        }
        .sav-modal-footer .sav-btn { width: auto; min-width: 110px; }

        /* Responsive: stack panel below form on small screens */
        @media (max-width: 991px) {
          .sav-panel { position: static; margin-top: 16px; }
        }
      `}</style>
    </>
  );
}
